import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
export class NodeWidget extends BaseComponent {
	
	constructor() {
		super();
		
		var nodeWidget = this;
		setTimeout(function(){
			nodeWidget.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var nodeWidget = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				}
			]
		});
		
		var nodeContainer = ElementUtil.create({
			tag: 'div',
			slot: 'primary',
			style: 'height: 100%; overflow: auto'			
		});
		
		
		var mainContent = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [	
				toolbar,
				nodeContainer,				
				{
					tag: 'style',
					innerHTML: `					
						.node-id {
							font-size: 18px;
							font-weight: bold;
						}
						.node-detail {
							color: #585858;
						}
						.node-status {
							background-color: yellow;
							padding: 5px;
							text-align: center;
							border-radius: 6px;
						}
						.node-selected {
							outline: none;
							border: 2px solid #dadada;
							border-radius: 7px;
							border-color: #9ecaed;
							box-shadow: 0 0 10px #9ecaed;
						}
						.node-current {
							background-color: #c9def1;
							border: 1px solid lightgrey;
							padding: 5px;
							border-radius: 5px 5px 5px 5px
						}
					`
				}
			]
		});
		
		
		
		
		nodeWidget.append(mainContent);
		
		
		var actionRefresh = function() {
			ElementUtil.removeAllChildren(nodeContainer);
			var loadMask = nodeWidget.showLoading();
			Service.getNodeService().getNodes().then(function(nodes){
				loadMask.remove();
				
				nodes.forEach(function(node) {
				
					var statusBackgroundColor = 'background: linear-gradient(209deg, rgb(197 227 205) 0%, rgb(156 225 175) 42%, rgb(103 159 117) 100%);'; //'#cef7d9';
					//check if offline
					if (!node.online) {
						node.status = "OFFLINE / Failed Check In";
						statusBackgroundColor = 'background: linear-gradient(209deg, rgb(247 57 57) 0%, rgb(243 173 173) 42%, rgb(255 122 122) 100%);';
						node.offline = true;
					} else {
						if (node.userDisabled || node.systemDisabled) {
							statusBackgroundColor = 'background-color: lightgrey';
							node.status = node.status + ' (DISABLED: ' + (node.userDisabled ? 'User Disabled ' : '') +  (node.systemDisabled ? 'System Disabled ' : '') + ' )';
						} else {
							if (node.status === 'ONLINE') {
								statusBackgroundColor = 'background: linear-gradient(209deg, rgb(197 227 205) 0%, rgb(156 225 175) 42%, rgb(103 159 117) 100%);'; //#cef7d9';
							} else if (node.status === 'BUSY') {
								statusBackgroundColor = 'background: linear-gradient(209deg, rgba(255,247,208,1) 0%, rgba(255,228,67,1) 42%, rgba(247,246,206,1) 100%);';
							} 
						}
					}

					var currentNode = '';
					if (node.currentNode) {
						currentNode = '<span class="node-current">Current</span>';
					}

					var acceptJobs = 'All';
					var skipJobs = 'None';					
					if (node.acceptJobs) {
						acceptJobs = node.acceptJobs;
					}
					if (node.skipJobs) {
						skipJobs = node.skipJobs;
					}
					
					var systemHealth = 'Healthy';
					if (node.systemDisableReason) {
						systemHealth = node.systemDisableReason;
					}

					var primaryDetails = `
						<div class="node-id">${node.nodeId} ${currentNode}</div>
						<div class="node-detail"><b>Start Date: </b>${TimeUtil.formatDateStandard(TimeUtil.parseDate(node.startTime))}</div>
						<div class="node-detail"><b>Uptime: </b>${TimeUtil.milliToDisplay(node.upTime)}</div>
						<div class="node-detail"><b>Last Check Date: </b>${TimeUtil.formatDateStandard(node.lastCheckInDts)}</div>
						<div class="node-detail"><b>App Version: </b>${node.appVersion}</div>
						<div class="node-detail"><b>Accept Jobs: </b>${acceptJobs}</div>	
						<div class="node-detail"><b>Skip Jobs: </b>${skipJobs}</div>
						<div class="node-detail"><b>System Health: </b>${systemHealth}</div>					
						<div class="node-status">Status: ${node.status}</div>
					`;
					
					var systemStatus = `
						<div class="node-id"></div>
						<div class="node-detail">CPU Load: ${node.cpuLoad} / ${node.cpuCount} | (${node.cpuPercentage})% <vaadin-progress-bar value="${node.cpuPercentage}" min="0" max="100"></vaadin-progress-bar> </div>
						<div class="node-detail">Memory: ${Math.floor(node.useMemory / 1024)}kb / ${Math.floor(node.maxMemory / 1024)}kb <vaadin-progress-bar value="${node.useMemory / node.maxMemory}"></vaadin-progress-bar></div>
						<div class="node-detail">Live Thread Count: ${node.liveThreadCount}</div>						
					`;
					

					var nodeView = ElementUtil.create({
						tag: 'div',
						theme: 'padding spacing',
						style: 'margin: 20px; color: black; border: 1px solid lightgrey; border-radius: 5px; box-shadow: 6px 7px 6px -3px black; ' + statusBackgroundColor,
						children: [
							{
								tag: 'div',
								style: 'padding: 10px;',
								trustedInnerHTML: true,
								innerHTML: primaryDetails,
								children: [
									{
										tag: 'dl-toolbar',
										theme: 'spacing',
										'class': node.offline ? 'hide' : '',
										listeners: {
											'action-menu-open': function(event){												
												event.target.parentNode.classList.add('node-selected');
											},
											'action-menu-close': function(event){
												event.target.parentNode.classList.remove('node-selected');
											}
										},
										children: [		
										]
									}
								]
							},
							{
								tag: 'div',
								style: 'padding: 10px;',
								trustedInnerHTML: true,
								innerHTML: systemStatus
							}
						]
					});

					nodeContainer.append(nodeView);
				});
			
			});
			
		};
		actionRefresh();
		
	}	
	
	
};
customElements.define('dl-node-widget', NodeWidget);


